import { render, staticRenderFns } from "./AreaSellBuyChart.vue?vue&type=template&id=921f0d10&scoped=true&"
import script from "./AreaSellBuyChart.vue?vue&type=script&lang=js&"
export * from "./AreaSellBuyChart.vue?vue&type=script&lang=js&"
import style0 from "./AreaSellBuyChart.vue?vue&type=style&index=0&id=921f0d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921f0d10",
  null
  
)

export default component.exports